// import { devtools } from 'zustand/middleware';
import { create } from 'zustand';

const store = (set) => ({
    currentEmlId: null,
    emlFlags: [],
    isPrintPreview: false,
    emlData: {},
    opinionModal: false,
    redirectUrl: false,
    reportUrl: false,
    checkedUrl: null,
    showModal: false,
    modalType: 'auto',
    msgViewDirection: {
        id: null,
        direction: ''
    }, //set state to check which direction user is opening message (prev or next), to get future params
    msgToolbarLinks: {},
    setCurrentEmlId: (id) => set({
        currentEmlId: typeof id === 'undefined' ? null : id
    }),
    setEmlFlags: (emlFlags) => set(
        { emlFlags }
    ),
    setEmlData: (emlData) => set(
        { emlData }
    ),
    setMsgToolbarLinks: (obj) => set(
        { obj }
    ),
    updateEmlFlags: (payload) => set((state) => {
        // console.log(payload);
        const { flag, set } = payload;
        const flagsList = [...state.emlFlags];
        const flagIdx = flagsList.indexOf(flag);
        // Mark as one of: seen, flagged, answered, forwarded
        if (set) {
            if (flagIdx === -1) flagsList.unshift(flag);
            // Mark as one of: unSeen, notFlagged, notAnswered, notForwarded
        } else {
            if (flagIdx !== -1) flagsList.splice(flagIdx, 1);
        }
        return { emlFlags: flagsList };
    }),
    setPrintPreview: (state = false) => set({ isPrintPreview: state }),
    setOpinionModal: (state = false) => set({ opinionModal: state }),
    //MAIL-6544 setReportUrl renew reportUrl
    setReportUrl: (url) => set(() => ({ reportUrl: url })),
    setCheckedUrl: (state = false) => set({ checkedUrl: state }),
    setShowModal: (state = false) => set({ showModal: state }),
    setModalType: (state) => set({ modalType: state }),
    setMsgViewDirection: (state = false) => set({ msgViewDirection: state }), //alwys pass both params (id, direction)
});

// const useMessageStore = create(devtools(store));
const useMessageStore = create(store);

export default useMessageStore;